var ownerLoginButton = document.getElementsByClassName("owner-login-button");

function handleOwnerLoginClick(e) {
  e.preventDefault();

  var $form = $("#owner-login-form");

  function checkRequiredFields() {
    $form.find('[required="required"]').each(function () {
      var $input = $(this);
      var fieldName = $input.attr("name");

      $input.addClass("error-field");
    });
  }
}

for (var i = 0; i < ownerLoginButton.length; i++) {
  ownerLoginButton[i].addEventListener("click", handleOwnerLoginClick);
}
